
































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { agencyStore } from '@/store/store';
import AgencyCostPlot from '@/modules/agencyCost/views/components/AgencyCostPlot.vue';
import AgencyCostComparisonContainer from '@/modules/agencyCost/views/components/AgencyCostComparisonContainer.vue';
import { getTotalActivityCost, getTotalActivityNpv } from '@/modules/agencyCost/lib/calculations/activity';
import { IAgencyCostActivityImperial, IAgencyCostImperial } from '@/modules/agencyCost/interfaces/agencyCost';

Component.registerHooks(['validations']);

interface IAgencyCostScenarioResult {
  scenario: IAgencyCostImperial,
  activities: IAgencyCostActivityResult[],
  totalCost: number,
  totalNpv: number
}

interface IAgencyCostActivityResult {
  activity: IAgencyCostActivityImperial,
  totalCost: number,
  totalNpv: number
}


@Component({
  components: {
    AgencyCostComparisonContainer,
    AgencyCostPlot,
  },
})
export default class AgencyCostComparison extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  get scenarioIds() {
    // @ts-ignore
    const scenarioString: string = this.$route.query.scenarios ? this.$route.query.scenarios : '';
    return scenarioString.split(',').map((v) => Number(v));
  }

  fields = [
    { key: 'edit', label: '' },
    { key: 'scenario' },
    { key: 'totalCost' },
    { key: 'totalNpv', label: 'Total NPV' },
  ];

  get results() {
    const results: any[] = [];
    
    this.sortActivities();

    this.scenariosImperial.forEach((s) => {
      console.log(s);

      const result: IAgencyCostScenarioResult = {
        scenario: s,
        activities: [],
        totalCost: 0,
        totalNpv: 0,
      };

      s.activities.forEach((a) => {
        const activityCost = getTotalActivityCost(a);
        const activityNpv = getTotalActivityNpv(a, s.discountRate_pct || 0);

        result.activities.push({
          activity: a,
          totalCost: activityCost,
          totalNpv: activityNpv,
        });

        result.totalCost += activityCost;
        result.totalNpv += activityNpv;
      });

      results.push(result);
    });


    return results;
  }

  mounted() {
    agencyStore.setComparisonIds(this.scenarioIds);
    agencyStore.getComparisonScenarios();
  }

  showDetails: boolean = true;

  sortActivities() {
    this.scenariosImperial.forEach((s) => s.activities.sort((a: IAgencyCostActivityImperial, b: IAgencyCostActivityImperial) => a.yearsAfterStart - b.yearsAfterStart));
  }


  get scenariosImperial() {
    return agencyStore.comparisonScenarios;
  }
}

